import { render } from "./Donnees.vue?vue&type=template&id=0a960d77"
import script from "./Donnees.vue?vue&type=script&lang=js"
export * from "./Donnees.vue?vue&type=script&lang=js"

import exportComponent from "/data/www/cavilam/boutique/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__